import React, { useEffect, useRef } from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import SelectObject from "./SelectObject";
import DatePicker from "./DatePicker";

interface ExitNoteState {
  exitDate: string;
  setExitDate: (date: string) => void;
  exitNote: string | undefined;
  setExitNote: (note: string) => void;
  exitType: string;
  setExitType: (type: string) => void;
  includeBan?: boolean;
  isBanned?: boolean;
  setIsBanned?: (ban: boolean) => void;
  duration?: string;
  setDuration?: (duration: string) => void;
  reassignMainContact?: boolean;
  newMainContact?: string;
  setNewMainContact?: (contact: string) => void;
  mainContactOptions?: any[];
}

const ExitNote = ({
  exitDate,
  setExitDate,
  exitNote,
  setExitNote,
  exitType,
  setExitType,
  includeBan = false,
  isBanned = false,
  setIsBanned = () => {},
  duration,
  setDuration = () => {},
  reassignMainContact = false,
  newMainContact,
  setNewMainContact = () => {},
  mainContactOptions,
}: ExitNoteState) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const durationOptions = [
    { key: "30", name: "30 Day" },
    { key: "60", name: "60 Day" },
    { key: "90", name: "90 Day" },
    { key: "180", name: "180 Day" },
    { key: "365", name: "1 Year" },
    { key: "indefinite", name: "Indefinite" },
  ];

  const exitTypesWBan: any[] = [
    { id: 0, key: "voluntary", name: "Voluntary" },
    { id: 1, key: "involuntary", name: "Involuntary" },
    { id: 2, key: "ban", name: "Ban" },
  ];

  const exitTypes: any[] = [
    { id: 0, key: "voluntary", name: "Voluntary" },
    { id: 1, key: "involuntary", name: "Involuntary" },
  ];

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  const onClickExitType = (e: any) => {
    setExitType(e.target.value);

    if (e.target.value === "ban") {
      setIsBanned(!isBanned);
    }
  };

  const updateBanDuration = (e: any) => {
    setDuration(e.target.value);
  };

  return (
    <>
      <Row className="mb-3">
        <Col xs={12}>
          <FloatingLabel controlId="floatingInput" label="Exit Note">
            <Form.Control
              as="textarea"
              type="textarea"
              ref={inputRef}
              placeholder="Exit Note"
              value={exitNote}
              onChange={(e) => setExitNote(e.target.value)}
            />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        {reassignMainContact && (
          <Col xs={4}>
            <SelectObject
              label="New Main Contact"
              initialOption="None"
              value={newMainContact}
              options={mainContactOptions}
              onUpdate={(e: any) => setNewMainContact(e.target.value)}
            />
          </Col>
        )}
        <Col xs={reassignMainContact ? 4 : 8}>
          <SelectObject
            label="Exit Type"
            value={exitType}
            options={includeBan ? exitTypesWBan : exitTypes}
            onUpdate={(e: any) => onClickExitType(e)}
          />
        </Col>
        <Col xs={4}>
          <DatePicker label="Exit Date" currentValue={exitDate} setCurrentValue={setExitDate} hasMaxDate={true} />
        </Col>
      </Row>
      {exitType === "ban" && (
        <Row className="mt-3">
          <Col xs={6}>
            <SelectObject label="Duration" value={duration} options={durationOptions} onUpdate={(e: any) => updateBanDuration(e)} />
          </Col>
        </Row>
      )}
    </>
  );
};

export default ExitNote;
